module.exports = __webpack_public_path__ + "img/ar.4987d1fb.svg";